import React from 'react';

import { ACMemberCalculations, formatACHOV } from '@/utils/accountingCenterCalculations';

interface ACMemberCalculationsFooterProps {
  calculations: ACMemberCalculations | null;
}

const ACMemberCalculationsFooter: React.FC<ACMemberCalculationsFooterProps> = ({ calculations }) => {
  if (!calculations) {
    return null;
  }

  return (
    <div className="space-y-4 w-full flex-1 bg-white md:bg-none rounded-[16px] p-4 md:p-0">
      <p className="text-xs md:text-sm flex items-center gap-2 justify-between md:justify-start text-secondary font-medium">
        <span>Accounting Center Hours Operative Value (ACHOV)</span>
        <span className="text-gray font-bold text-sm md:text-base">
          {formatACHOV(calculations.achov, calculations.currency)}
        </span>
      </p>
    </div>
  );
};

export default ACMemberCalculationsFooter;
